import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { SimpleModalService } from "ngx-simple-modal";
import { FinanceiroService } from "src/app/services/actions/financeiro.service";
import { UserService } from "src/app/services/user.service";
import * as XLSX from 'xlsx';
import { DefaultModalComponent } from "../../helpers/default-modal/default-modal.component";

export interface FinanceTable {
	name: string;
	dt_appointment: string;
	status: string;
	payment_method: string;
	gross_price: number;
	transaction_fee: number;
	transfer_fee: number;
	attenuate_transfer_fee: number;
	net_price: number;
	total_transfer_month: number;
	payment_date: string;
	transfer_date: string;
}

const ELEMENT_DATA: FinanceTable[] = [];


@Component({
	selector: "app-financeiro",
	templateUrl: "./financeiro.component.html",
	styleUrls: ["./financeiro.component.scss"],
})
export class FinanceiroComponent implements OnInit {
	constructor(
		private financeiroService: FinanceiroService,
		private userService: UserService,
		private DefaultModal: SimpleModalService,
	) {}

	/*name of the excel-file which will be downloaded. */ 
	fileName= 'ExcelSheet.xlsx'; 

	displayedColumns = [
		"name",
		"dt_appointment",
		"status",
		"payment_method",
		"gross_price",
		"transaction_fee",
		"transfer_fee",
		"attenuate_transfer_fee",
		"net_price",
		"total_transfer_month",
		"payment_date",
		"transfer_date"
	]

	bankCodes = {
		'001': 'Banco do Brasil S.A.',
		'033': 'Banco Santander (Brasil) S.A.',
		'104': 'Caixa Econômica Federal',
		'237': 'Banco Bradesco S.A.',
		'341': 'Banco Itaú S.A.',
		'356': 'Banco Real S.A. (antigo)',
		'389': 'Banco Mercantil do Brasil S.A.',
		'399': 'HSBC Bank Brasil S.A. - Banco Múltiplo',
		'422': 'Banco Safra S.A.',
		'453': 'Banco Rural S.A.',
		'633': 'Banco Rendimento S.A.',
		'652': 'Itaú Unibanco Holding S.A.',
		'745': 'Banco Citibank S.A.',
		'246': 'Banco ABC Brasil S.A.',
		'025': 'Banco Alfa S.A.',
		'641': 'Banco Alvorada S.A.',
		'029': 'Banco Banerj S.A.',
		'038': 'Banco Banestado S.A.',
		'000': 'Banco Bankpar S.A.',
		'740': 'Banco Barclays S.A.',
		'107': 'Banco BBM S.A.',
		'031': 'Banco Beg S.A.',
		'096': 'Banco BM&F de Serviços de Liquidação e Custódia S.A',
		'318': 'Banco BMG S.A.',
		'752': 'Banco BNP Paribas Brasil S.A.',
		'248': 'Banco Boavista Interatlântico S.A.',
		'036': 'Banco Bradesco BBI S.A.',
		'204': 'Banco Bradesco Cartões S.A.',
		'225': 'Banco Brascan S.A.',
		'044': 'Banco BVA S.A.',
		'263': 'Banco Cacique S.A.',
		'473': 'Banco Caixa Geral - Brasil S.A.',
		'222': 'Banco Calyon Brasil S.A.',
		'040': 'Banco Cargill S.A.',
		'M08': 'Banco Citicard S.A.',
		'M19': 'Banco CNH Capital S.A.',
		'215': 'Banco Comercial e de Investimento Sudameris S.A.',
		'756': 'Banco Cooperativo do Brasil S.A. - BANCOOB',
		'748': 'Banco Cooperativo Sicredi S.A.',
		'505': 'Banco Credit Suisse (Brasil) S.A.',
		'229': 'Banco Cruzeiro do Sul S.A.',
		'003': 'Banco da Amazônia S.A.',
		'083': '– Banco da China Brasil S.A.',
		'707': 'Banco Daycoval S.A.',
		'M06': 'Banco de Lage Landen Brasil S.A.',
		'024': 'Banco de Pernambuco S.A. – BANDEPE',
		'456': 'Banco de Tokyo-Mitsubishi UFJ Brasil S.A.',
		'214': 'Banco Dibens S.A.',
		'047': 'Banco do Estado de Sergipe S.A.',
		'037': 'Banco do Estado do Pará S.A.',
		'041': 'Banco do Estado do Rio Grande do Sul S.A.',
		'004': 'Banco do Nordeste do Brasil S.A.',
		'265': 'Banco Fator S.A.',
		'M03': 'Banco Fiat S.A.',
		'224': 'Banco Fibra S.A.',
		'626': 'Banco Ficsa S.A.',
		'394': 'Banco Finasa BMC S.A.',
		'M18': 'Banco Ford S.A.',
		'233': 'Banco GE Capital S.A.',
		'734': 'Banco Gerdau S.A.',
		'M07': 'Banco GMAC S.A.',
		'612': 'Banco Guanabara S.A.',
		'M22': 'Banco Honda S.A.',
		'063': 'Banco Ibi S.A. Banco Múltiplo',
		'M11': 'Banco IBM S.A.',
		'604': 'Banco Industrial do Brasil S.A.',
		'320': 'Banco Industrial e Comercial S.A.',
		'653': 'Banco Indusval S.A.',
		'630': 'Banco Intercap S.A.',
		'249': 'Banco Investcred Unibanco S.A.',
		'184': 'Banco Itaú BBA S.A.',
		'479': 'Banco ItaúBank S.A',
		'M09': 'Banco Itaucred Financiamentos S.A.',
		'376': 'Banco J. P. Morgan S.A.',
		'074': 'Banco J. Safra S.A.',
		'217': 'Banco John Deere S.A.',
		'065': 'Banco Lemon S.A.',
		'600': 'Banco Luso Brasileiro S.A.',
		'755': 'Banco Merrill Lynch de Investimentos S.A.',
		'746': 'Banco Modal S.A.',
		'151': 'Banco Nossa Caixa S.A.',
		'045': 'Banco Opportunity S.A.',
		'623': 'Banco Panamericano S.A.',
		'611': 'Banco Paulista S.A.',
		'643': 'Banco Pine S.A.',
		'638': 'Banco Prosper S.A.',
		'747': 'Banco Rabobank International Brasil S.A.',
		'M16': 'Banco Rodobens S.A.',
		'072': 'Banco Rural Mais S.A.',
		'250': 'Banco Schahin S.A.',
		'749': 'Banco Simples S.A.',
		'366': 'Banco Société Générale Brasil S.A.',
		'637': 'Banco Sofisa S.A.',
		'464': 'Banco Sumitomo Mitsui Brasileiro S.A.',
		'082': '– Banco Topázio S.A.',
		'M20': 'Banco Toyota do Brasil S.A.',
		'634': 'Banco Triângulo S.A.',
		'208': 'Banco UBS Pactual S.A.',
		'M14': 'Banco Volkswagen S.A.',
		'655': 'Banco Votorantim S.A.',
		'610': 'Banco VR S.A.',
		'370': 'Banco WestLB do Brasil S.A.',
		'021': 'BANESTES S.A. Banco do Estado do Espírito Santo',
		'719': 'Banif-Banco Internacional do Funchal (Brasil)S.A.',
		'073': 'BB Banco Popular do Brasil S.A.',
		'078': 'BES Investimento do Brasil S.A.-Banco de Investimento',
		'069': 'BPN Brasil Banco Múltiplo S.A.',
		'070': 'BRB – Banco de Brasília S.A.',
		'477': 'Citibank N.A.',
		'081': '– Concórdia Banco S.A.',
		'487': 'Deutsche Bank S.A. – Banco Alemão',
		'751': 'Dresdner Bank Brasil S.A. – Banco Múltiplo',
		'062': 'Hipercard Banco Múltiplo S.A.',
		'492': 'ING Bank N.V.',
		'488': 'JPMorgan Chase Bank',
		'409': 'UNIBANCO – União de Bancos Brasileiros S.A.',
		'230': 'Unicard Banco Múltiplo S.A.'
	}

	data: any = []
	dataSource: any = []
	totalAmountReceived
	totalAvailable
	totalWaitingFunds
	loading = true
	modalInfoTitle
	modalInfoContent
	lastTransfer
	bankAccount
	transactions = []
	loading_table = true

	ngOnInit () {
		this.financeiroService
			.getFinanceiroTotais(this.userService.getId())
			.subscribe(
				(res: any) => {
					this.totalAmountReceived = res.recebedorTotalBalance.transferred.amount ? this.formatMoney(res.recebedorTotalBalance.transferred.amount) : this.formatMoney(0)
					this.totalAvailable = res.recebedorTotalBalance.available.amount ? this.formatMoney(res.recebedorTotalBalance.available.amount) : this.formatMoney(0)
					this.totalWaitingFunds = res.recebedorTotalBalance.waiting_funds.amount ? this.formatMoney(res.recebedorTotalBalance.waiting_funds.amount) : this.formatMoney(0)
					this.lastTransfer = res.accountData.last_transfer ? this.formatDate(res.accountData.last_transfer) : 'Sem transferências para sua conta ainda'
					this.bankAccount = res.accountData.bank_account
					this.loading = false
				},
				(err) => {
					console.log(err)
				}
			);
		this.financeiroService
			.getFinanceiro(this.userService.getId())
			.subscribe(
				(res: any) => {
					if (res) {
						this.transactions = res
						this.loading_table = false
					}
				},
				(err) => {
					console.log(err);
				}
			);
	}

	exportexcel (): void {
		/* table id is passed over here */   
		let element = document.getElementById('excel-table'); 
		const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

		/* generate workbook and add the worksheet */
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		XLSX.writeFile(wb, this.fileName);	
  }

	formatMoney (money) {
		return (money/100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
	}

	modalInfoTotalRecebido () {
		this.DefaultModal.addModal(DefaultModalComponent, {
			title: 'Total recebido',
			message: 'Esse valor representa o que você já transferiu para sua conta bancária (quanto já recebeu efetivamente).'
		})
	}

	modalInfoTotalDisponivel () {
		this.DefaultModal.addModal(DefaultModalComponent, {
			title: 'Total disponível para saque',
			message: 'Esse valor representa o que você tem disponível em sua conta para receber na próxima transferência.'
		})
	}

	modalInfoTotalWainting () {
		this.DefaultModal.addModal(DefaultModalComponent, {
			title: 'Valor futuro para receber',
			message: 'Esse valor representa o que você tem a receber em valores futuros (ainda não disponíveis).'
		})
	}

	formatDate (dateInput) {
    return moment(dateInput).format('DD/MM/YYYY')
  }

	paymentsFormat (payemnt) {
		if (payemnt === 'pix') return 'PIX'
		if (payemnt === 'boleto') return 'BOLETO'
		if (payemnt === 'credit_card') return 'CARTÃO DE CRÉDITO'
		if (payemnt === 'Transferência') return 'Transferência para sua conta'
	}
}
